import { setReplaceText } from './format';

export const enrichObjectData = <T extends Record<string, string | number | undefined | null>>(
  data: T,
  replaceText: Record<string, string>
): Record<keyof T, string> => {
  const enrichedData = {} as Record<keyof T, string>;

  for (const key in data) {
    const keyType = key as keyof typeof data;
    const dataValue = data[keyType];

    if (dataValue !== null) {
      const value = dataValue ? dataValue.toString() : '';
      const enrichedValue = setReplaceText(value, replaceText);
      enrichedData[key as keyof T] = enrichedValue;
    }
  }

  return enrichedData;
};

